/**
 * Central API fetch utility.
 *
 * Usage (mirrors the native fetch signature):
 *   import apiFetch from './api';
 *   const res = await apiFetch('/eventgenerator', { method: 'POST', body: ... });
 *
 * The function:
 *  1. Prepends API_PREFIX so calls reach the correct backend regardless of
 *     deployment topology (multi-domain vs single-domain /api).
 *  2. Always sends credentials (session cookie).
 *  3. Always sets X-Requested-With so Spring Security treats the request as
 *     an XHR and returns 401 instead of a redirect on auth failure.
 */

import { API_PREFIX } from './config';

/**
 * @param {string} path   – must start with "/"  e.g. "/login", "/eventgenerator"
 * @param {RequestInit} [options]
 * @returns {Promise<Response>}
 */
export default function apiFetch(path, options = {}) {
    const url = `${API_PREFIX}${path}`;

    const headers = new Headers(options.headers || {});
    if (!headers.has('X-Requested-With')) {
        headers.set('X-Requested-With', 'XMLHttpRequest');
    }

    return fetch(url, {
        ...options,               // copy method, body, etc. from caller
        credentials: 'include',   // always send the session cookie (overrides caller)
        headers,                  // always use the processed Headers instance
    });
}
